// Ported verbatim from vue3/src/features/customer-display/format.js (pure,
// framework-independent - duplicated rather than shared because it is
// page-local presentation logic, not a cross-app protocol/API module; those
// stay in frontend/shared/customer-display/ and are imported by both apps
// unchanged). Keep the two copies in sync if this ever changes.
const money = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function formatMoney(value) {
  return money.format(Number(value) || 0);
}

// Full phone number (an intentional product requirement), grouped for reading.
export function formatPhone(digits) {
  const d = String(digits || '');
  if (d.length === 10) return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
  if (d.length === 9) return `${d.slice(0, 2)}-${d.slice(2, 5)}-${d.slice(5)}`;
  return d;
}

export const PAYMENT_CHANNEL_LABELS = {
  cash: 'เงินสด',
  transfer: 'โอนเงิน',
  credit: 'บัตรเครดิต',
  cheque: 'เช็ค'
};

// What the reference number means depends on the channel: a bank name, the
// last digits of a card, or a cheque number.
export function formatSettlementReference(channel, reference) {
  if (!reference) return '';
  if (channel === 'transfer') return `ธนาคาร ${reference}`;
  if (channel === 'credit') return `เลขบัตรลงท้าย ${reference}`;
  if (channel === 'cheque') return `เลขที่เช็ค ${reference}`;
  return reference;
}

export const DOC_TYPE_LABELS = {
  quotation: 'ใบเสนอราคา',
  invoice: 'ใบแจ้งหนี้',
  receipt: 'ใบเสร็จรับเงิน',
  'debit-note': 'ใบลดหนี้',
  'credit-note': 'ใบเพิ่มหนี้'
};
